import React, { useState, useEffect } from 'react'
import ClientCheck from '../../system/client/ClientCheck';
import dayjs from 'dayjs';
import { Table } from 'antd';
import ReportCheck from './ReportCheck';    
import classes from './report.module.css';
import StateTag from '../../cpn/StateTag';
function ReportListNeedApprove(props) {
    const [list, setList] = useState(props.spList);
    useEffect(() => {
        const arr = props.spList.filter((item) => item.dsbzd_sp_state === '2' && item.dsbzd_sp_jd_name === '审批');
        setList(arr);
    }, [props.spList]);
    const columns = [
        {
            title: '团队名称',
            dataIndex: 'dsbzd_sp_dsbzd_name',
            key: 'dsbzd_sp_dsbzd_name',
            width: "20%",
            render: (_, record) =>  <ReportCheck 
                                        dsbzd_id={record.dsbzd_sp_dsbzd_id} 
                                        dsbzd_name={record.dsbzd_sp_dsbzd_name} 
                                        dsbzd_date={record.dsbzd_sp_dsbzd_date}
                                        dsbzd_date_end={record.dsbzd_sp_dsbzd_date_end}
                                        dsbzd_kh_id={record.dsbzd_sp_dsbzd_kh_id}
                                        dsbzd_kh_name={record.dsbzd_sp_dsbzd_kh_name}
                                        yh_id={props.yh_id}  
                                        yh_name={props.yh_name} 
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name}
                                    />
        },
        {
            key: 'dsbzd_sp_dsbzd_date',
            dataIndex: 'dsbzd_sp_dsbzd_date',
            title: "开始日期",
            width: "6%",            
        },
        {
            key: 'dsbzd_sp_dsbzd_date_end',
            dataIndex: 'dsbzd_sp_dsbzd_date_end',
            title: "结束日期",
            width: "6%",
        },
        {
            key: 'dsbzd_sp_dsbzd_date_end',
            dataIndex: 'dsbzd_sp_dsbzd_date_end',
            title: "天数",
            width: "3%",
            render: (_, record) => <>{dayjs(record.dsbzd_date_end).diff(dayjs(record.dsbzd_date), 'day') + 1}</>,
        },
      
        {
            key: 'dsbzd_sp_dsbzd_kh_name',
            dataIndex: 'dsbzd_sp_dsbzd_kh_name',
            title: "客户",
            width: "8%",
            render: (text, record) => <ClientCheck kh_id={record.dsbzd_sp_dsbzd_kh_id} kh_name={record.dsbzd_sp_dsbzd_kh_name} qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            key: 'dsbzd_sp_uname',
            dataIndex: 'dsbzd_sp_uname',
            title: "提交人",
            width: "8%",
            render: (text, record) => <>{record.dsbzd_sp_uname} {record.dsbzd_sp_ctime}</>,
        },
        {
            title: '状态',
            dataIndex: 'dsbzd_sp_state',
            width: '5%',
            key: 'dsbzd_sp_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'dsbzd_sp_dsbzd_id',
            width: '5%',
            key: 'dsbzd_sp_dsbzd_id',                        
        },       
    ]
    return (
        <>
            <Table 
                className={classes.customTable}
                size='small'
                bordered
                dataSource={list} 
                columns={columns} 
                rowKey='dsbzd_sp_id'
                locale={{
                    emptyText: '暂无团队报账单' // This will display text when the table is empty
                }}
            />

        </>
    )
}

export default ReportListNeedApprove